export type Language = 'en' | 'hi';

export const translations = {
  en: {
    // Nav & Header
    'app.title': 'AgriTech',
    'app.subtitle': 'AI Plant Disease Detection',
    'nav.home': 'Home',
    'nav.scan': 'Scan',
    'nav.market': 'Market',
    'nav.weather': 'Weather',
    'auth.signin': 'Sign In',
    'auth.signup': 'Sign Up',
    
    // Sections
    'section.supported_crops': 'Supported Crops',
    'section.weather': 'Weather Update',
    'section.farming_insights': 'Farming Insights',

    // Sliders
    'slider.1.title': 'AgriTech Insights',
    'slider.1.desc': 'Discover intelligent solutions for modern farming.',
    'slider.2.title': 'Advanced AI Detection',
    'slider.2.desc': '95%+ accuracy in identifying plant diseases',
    'slider.3.title': 'Real-time Analysis',
    'slider.3.desc': 'Get instant results with our fast processing',
    'slider.4.title': 'Multiple Crops Supported',
    'slider.4.desc': 'Tomato, Potato, Pepper and more',

    // Weather
    'weather.refresh': 'Refresh',
    'weather.unavailable': 'Weather data unavailable',
    'weather.recommendations': 'Farming Recommendations',
    'weather.forecast': '3-Day Forecast',

    // Insights
    'insights.irrigation': 'Irrigation Tip',
    'insights.irrigation.desc': 'Water crops early morning to reduce evaporation and improve soil moisture retention throughout the day.',
    'insights.soil': 'Soil Health',
    'insights.soil.desc': 'Monitor soil pH and nutrient levels regularly to ensure optimal conditions for enhanced crop yields.',
    'insights.sunlight': 'Sunlight Guide',
    'insights.sunlight.desc': 'Ensure your most critical crops receive 6-8 hours of direct, unobstructed sunlight daily for max growth.',
  },
  hi: {
    // Nav & Header
    'app.title': 'एग्रीटेक',
    'app.subtitle': 'एआई पौध रोग पहचान',
    'nav.home': 'होम',
    'nav.scan': 'स्कैन',
    'nav.market': 'बाज़ार',
    'nav.weather': 'मौसम',
    'auth.signin': 'लॉग इन',
    'auth.signup': 'साइन अप',
    
    // Sections
    'section.supported_crops': 'समर्थित फसलें',
    'section.weather': 'मौसम की जानकारी',
    'section.farming_insights': 'खेती के सुझाव',

    // Sliders
    'slider.1.title': 'एग्रीटेक इनसाइट्स',
    'slider.1.desc': 'आधुनिक खेती के लिए बुद्धिमान समाधान खोजें।',
    'slider.2.title': 'उन्नत एआई पहचान',
    'slider.2.desc': 'पौधों की बीमारियों की पहचान में 95%+ सटीकता',
    'slider.3.title': 'वास्तविक समय विश्लेषण',
    'slider.3.desc': 'हमारे तेज़ प्रोसेसिंग के साथ तुरंत परिणाम प्राप्त करें',
    'slider.4.title': 'कई फसलें समर्थित',
    'slider.4.desc': 'टमाटर, आलू, मिर्च और बहुत कुछ',

    // Weather
    'weather.refresh': 'रिफ्रेश करें',
    'weather.unavailable': 'मौसम का डेटा उपलब्ध नहीं है',
    'weather.recommendations': 'खेती की सिफारिशें',
    'weather.forecast': '3-दिन का पूर्वानुमान',

    // Insights
    'insights.irrigation': 'सिंचाई टिप',
    'insights.irrigation.desc': 'वाष्पीकरण को कम करने और पूरे दिन मिट्टी की नमी बनाए रखने के लिए सुबह जल्दी फसलों को पानी दें।',
    'insights.soil': 'मिट्टी का स्वास्थ्य',
    'insights.soil.desc': 'बढ़ी हुई फसल उपज के लिए अनुकूल परिस्थितियों को सुनिश्चित करने के लिए नियमित रूप से मिट्टी के पीएच और पोषक तत्वों के स्तर की निगरानी करें।',
    'insights.sunlight': 'सूर्य के प्रकाश गाइड',
    'insights.sunlight.desc': 'सुनिश्चित करें कि आपकी सबसे महत्वपूर्ण फसलों को अधिकतम विकास के लिए प्रतिदिन 6-8 घंटे सीधे, अबाधित धूप मिले।',
  }
};
